import { useSelectStoreItemProvider } from '#components/organisms/modals/SelectStoreItemModalFlow.js';
import {
  useShowConsumerCampaignById,
  useShowConsumerCampaignSettingsById,
  useShowStoreCause,
} from '@givebacks/api/store';
import { EndedCampaignAlert } from 'core/Components';
import { useCrowdFundingTranslations } from 'core/Hooks';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group } from 'ui';
import { SplitLayoutCard } from 'ui/Core';

import { useCampaignInfoByProvider } from '../../../api/new/campaigns/utils/campaignUtils';
import { CampaignProgressWithStats } from '../Progress/CampaignProgress';

const CampaignStatsCard = () => {
  const { openModalById } = useSelectStoreItemProvider({});

  const navigate = useNavigate();
  const { causeId, campaignId } = useCampaignInfoByProvider();

  const { data: campaign } = useShowConsumerCampaignById({ causeId, campaignId });
  const { data: settings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });
  const { t } = useCrowdFundingTranslations(causeId);
  const { data: storeCause } = useShowStoreCause({ causeId });

  return (
    <SplitLayoutCard
      topComponent={<CampaignProgressWithStats />}
      bottomComponent={
        settings?.isCampaignReadOnly ? (
          <EndedCampaignAlert type="campaign" />
        ) : (
          <Group grow>
            {storeCause?.donations_enabled && (
              <ButtonMantine
                variant="gradient"
                onClick={() => {
                  openModalById('StoreItemDonateOptions');
                }}
              >
                {t('Donate')}
              </ButtonMantine>
            )}
            {settings?.isRegistrationOpen && (
              <ButtonMantine onClick={() => navigate('participant-center/register')}>
                {campaign?.participant_options.registration_call_to_action}
              </ButtonMantine>
            )}
          </Group>
        )
      }
    />
  );
};

export { CampaignStatsCard };
